import { IIssue, IIssueResourceData } from "../IssueForRelations";

export class LogFiltersBuildier {
   

	private filters: string[];
	private issue: IIssue

	constructor(filters: string[], issue: IIssue) 
	{
		this.issue = issue;
		this.filters = filters;
	}

	public buildForServices(): string
	{
		return this.createLinkedResource(this.issue.linkedServiceAssets);
	}

	public buildForApplications(): string {
		return this.createLinkedResource(this.issue.businessApplicationsAssets);
	}

	public buildForBusinessProcess(): string {
		return this.createLinkedResource(this.issue.businessProcessesAssets);
	}

	public buildForDataSets(): string {
		return this.createLinkedResource(this.issue.dataSetAssets);
	}

	private createLinkedResource(resources: IIssueResourceData[]): string {
		if (!this.filters) {
			return "";
		}
		var filtersTemp = this.filters.filter(x => x == "linkedResource")
		if (filtersTemp.length > 0) {
			let ids = resources.map(x => x.id).join(",");
			return `resource IN (${ids})`;
		}
		return "";
	}
}